


































import Vue from "vue";
import permission, { PermissionName } from "@/common/mixins/permission";
import dialog from "@/common/mixins/dialog";
import { Order } from "../models/Order";
import { OrderTable } from "../forms/OrderTableForm";
import { OrderUpdateDeliveryMode } from "../forms/OrderUpdateDeliveryModeForm";
import { DeliveryMode } from "../../delivery-modes/models/DeliveryMode";
import { required, integer } from "vuelidate/lib/validators";
export default Vue.extend({
  mixins: [dialog, permission],
  validations: {
    orderUpdateDeliveryMode: {
      mcNumber: { required },
      deliveryMode: { id: { required } }
    }
  },
  data() {
    const orderUpdateDeliveryMode: OrderUpdateDeliveryMode = {
      mcNumber: "",
      deliveryMode: { id: "" }
    };
    const deliveryModes: DeliveryMode[] = [];
    return {
      orderUpdateDeliveryMode,
      deliveryModes
    };
  },
  async created() {
    await this.getAllDeliveryModes();
  },
  methods: {
    async getAllDeliveryModes() {
      try {
        const {
          data,
          meta
        } = await (this as any).$dep.deliveryModeUseCase.getDeliveryModes({
          perPage: 99999,
          search: ""
        });
        this.deliveryModes = data;
      } catch (error) {
        console.log(error);
      }
    },
    async updateDeliveryMode() {
      try {
        const {
          data
        } = await (this as any).$dep.orderUseCase.updateDeliveryModeByMcNumber(
          this.orderUpdateDeliveryMode
        );
        (this as any).alertSuccess("Success", "Update Delivery Mode สำเร็จ");
      } catch (error) {
        if (error.response.data.message) {
          (this as any).alertError("Error", error.response.data.message);
        } else {
          (this as any).alertError("Error", error);
        }
      }
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;
      const isConfirmed = await (this as any).alertConfirm(
        "Confirm to update Delivery Mode",
        "คุณต้องการอัพเดท Delivery Mode หรือไม่ ?"
      );
      if (isConfirmed) {
        await this.updateDeliveryMode();
      }
    }
  }
});
